import {
  Divider,
  TextField,
  Grid,
  Typography,
  Button,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import PropTypes from 'prop-types';
import { useState } from 'react';
import ConfirmationModal from '../common/confirmationModal/ConfirmationModal';
import { useAppSelector } from 'src/hooks/hooks';

interface Props {
  open: boolean,
  onClose: any,
  onSubmit: any,
  getData: any,
  navigationPath?: string,
  leaveDetails?: any
}

const RejectReasonForm = (props: Props) => {

  const [isDisableReject, setIsDisableReject] = useState(true);
  const [rejectReason, setRejectReason] = useState('');
  const [openRejectConfirmation, setOpenRejectConfirmation] = useState(false);
  const { isLoading } = useAppSelector((state) => state.appReducer);


  const TextFieldStyle = {
    paddingTop: 2,
    paddingLeft: 15,
    paddingRight: 15,
    fontSize: '12px'
  };

  const LabelStyle = {
    paddingLeft: 15,
    paddingRight: 15,
    fontSize: '13px',
    fontFamily:
      'Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"'
  };

  const selectStyle = {
    width: '94%',
    marginLeft: 15,
    marginTop: 5,
    paddingRight: 15,
    fontSize: '12px',
    height: '2.25rem'
  };

  const titleStyles = {
    fontWeight: '700',
    fontSize: '15px',
    fontFamily:
      'Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"'
  };

  const rejectBtnDisableStyle = { 
    backgroundColor: '#F8F2F2', 
    color: 'red',
    opacity: 0.4
  }

  const rejectBtnStyle = {
    backgroundColor: '#F8F2F2', 
    color: 'red'
  }

  const handleClose = () => {
    props.onClose();
  };

  const handleSubmit = () => {
    props.onSubmit();
  }

  const handleData = (rejectReason) => {
    const sendData = {
      reason: rejectReason
    }
    props.getData(sendData)
  }

  const validateRejectComfirmation = () => {
    setOpenRejectConfirmation(!openRejectConfirmation);
  }

  return (
    <Dialog
      open={props.open}
      maxWidth="md"
      fullWidth
      scroll="paper"
      onClose={handleClose}
      onSubmit={handleSubmit}
    >
      <form>
        <>
          <Grid
            item
            xs={12}
            style={{ marginTop: '2rem' }}
            sx={{ mt: 5, pb: 2, pl: 2 }}
          >
            <Typography style={titleStyles}>Reject Reason
            <span style={{ color: 'red', marginLeft: '3px' }}>*</span>
            </Typography>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                size="small"
                multiline
                rows={8}
                className="input-text"
                style={TextFieldStyle}
                inputProps={{
                  style: {
                    fontSize: '13px'
                  },
                  maxLength: 200
                }}
                fullWidth
                placeholder="Enter reject reason"
                variant="outlined"
                onChange={(e) => {
                  setRejectReason(e.target.value);
                  if(e.target.value.trim()){
                    setIsDisableReject(false);
                  } else {
                    setIsDisableReject(true);
                  }
                }}
              />
            </Grid>
          </Grid>
          <Grid 
            item
            sx={{
              mb: 2,
              mt: 2,
              pr: 2,
              display: 'flex',
              justifyContent: 'flex-end'
            }}>
            <Button
              sx={{
                width: '100px',
                ml: 2,
                fontSize: '13px',
                fontWeight: 'normal',
                background: '#F5F7FF',
                color: '#5569ff'
              }}
              variant="contained"
              onClick={(e) => {
                handleClose();
              }}
            >
              Cancel
            </Button>
            <Button
              sx={{
                width: '100px',
                fontWeight: 'normal',
                background: '#F5F7FF',
                fontSize: '13px',
                ml: 2,
              }}
              disabled={isDisableReject}
              style={isDisableReject ? rejectBtnDisableStyle : rejectBtnStyle}
              onClick={() => { validateRejectComfirmation() }}
            >
              Reject
            </Button>
          </Grid>
          <ConfirmationModal
            isLoading={isLoading}
            open={openRejectConfirmation}
            toggle={validateRejectComfirmation}
            message={
              props.navigationPath === 'pending'
                ? props.leaveDetails?.leaveType === 'Work From Home'
                ? `Are you sure you want to reject this work from home request?`
                : `Are you sure you want to reject this leave?`
                : props.navigationPath === 'leiLeave'
                ? `Are you sure you want to reject this eligibility request?`
                : `Are you sure you want to reject this PM/RM approved request?`
            }
            onConfirm={() => handleData(rejectReason)}
            noToggle={validateRejectComfirmation}
          />
        </>
      </form>
    </Dialog>
  );
}

RejectReasonForm.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  getData: PropTypes.any,
  employeeList: PropTypes.array.isRequired
};

export default RejectReasonForm;
